import React, { useEffect, useRef } from "react";
import {
  BoldOutlined,
  ItalicOutlined,
  LinkOutlined,
  OrderedListOutlined,
  UnderlineOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";

const HtmlEditor = ({ value, onChange, placeholder = "Write content" }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || "";
    }
  }, [value]);

  const updateValue = () => {
    onChange(editorRef.current?.innerHTML || "");
  };

  const runCommand = (command, commandValue = null) => {
    editorRef.current?.focus();
    document.execCommand(command, false, commandValue);
    updateValue();
  };

  const addLink = () => {
    const url = window.prompt("Enter URL");
    if (!url) return;
    runCommand("createLink", url);
  };

  return (
    <div className="qrl-html-editor">
      <div className="qrl-html-toolbar">
        <button type="button" onClick={() => runCommand("bold")} title="Bold"><BoldOutlined /></button>
        <button type="button" onClick={() => runCommand("italic")} title="Italic"><ItalicOutlined /></button>
        <button type="button" onClick={() => runCommand("underline")} title="Underline"><UnderlineOutlined /></button>
        <button type="button" onClick={() => runCommand("insertUnorderedList")} title="Bulleted list"><UnorderedListOutlined /></button>
        <button type="button" onClick={() => runCommand("insertOrderedList")} title="Numbered list"><OrderedListOutlined /></button>
        <button type="button" onClick={addLink} title="Add link"><LinkOutlined /></button>
        <button type="button" onClick={() => runCommand("removeFormat")} title="Clear formatting">Tx</button>
      </div>
      <div
        ref={editorRef}
        className="qrl-html-surface"
        contentEditable
        data-placeholder={placeholder}
        onInput={updateValue}
        onBlur={updateValue}
        suppressContentEditableWarning
      />
    </div>
  );
};

export default HtmlEditor;
